export default __webpack_public_path__ + "static/media/need-for-speed-shift.cac08fd5.png";